import { render } from "./LinkedGuestPass.vue?vue&type=template&id=279a95e1"
import script from "./LinkedGuestPass.vue?vue&type=script&lang=js"
export * from "./LinkedGuestPass.vue?vue&type=script&lang=js"

import exportComponent from "C:\\workspaces\\guest-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__